<template>
  <div class="Melamine">
    <div class="title">Tetrahydrofuran</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Standard" label="Standard"> </el-table-column>
        <!-- <el-table-column prop="Results" label="Results"> </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>In 180kg drums, 14.4mt/20 FCL and 25.2mt/40FCL... Orin ISO tanks</p>
    </div>
    <div class="item-huanhang">
      <label>Product Description:</label>
      <p>
        Tetrahydrofuran (THF) is a clear, colorlessliquid with an ether-like
        odor. The principal end uses of THF include PTMEG, pharmaceutical
        solvenit, adhesives, PVC cement and magnetic tape. Due to its' tendency
        to form peroxides during storage, THFis inhibited with BHT.
      </p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        As a resin solvent, THF is used in: . Flexographic inks forplastics
        Coating deposition for audio and video tapes . PVC and CPVC pipe
        cements. Polyurethane coatings . PVC film casting (food packaging) As a
        reaction solvent, THF can be used in: . Griggnard Reagent formation
        processes Pharmaceutical steroids. Preparation of organometallic
        reagents AAs a reactant precursor for specialty derivatives: Pyrrolidine
        (used in the pharmaceutical industry) Polytetrahdrofuran (used in the
        plastic industry)
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "Appearance",
          Standard: "Colorless transparent liquid",
          Results: "Pass",
        },
        { Item: "Purity", Standard: "99.9% min", Results: "99.95%" },
        { Item: "Color", Standard: "5 APHA max", Results: "<5 APHA" },
        { Item: "Water content", Standard: "200ppm max", Results: "<100ppm" },
        { Item: "Peroxide", Standard: "10ppm max", Results: "5ppm" },
        {
          Item: "Antioxidant, PPM",
          Standard: "As per customer's requirement",
          Results: "",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
